import { ReactNode } from "react"
import StyledOptionContentDisplay from "./option-content-display-styled"

const OptionContentDisplay = ({ minWidth, children}:{minWidth: string, children: ReactNode}) => {
    return(<StyledOptionContentDisplay minWidth={minWidth}>
        {children}
    </StyledOptionContentDisplay>)
}

export default OptionContentDisplay;